export default {
  title: {
    receipt: 'Receipt',
    receiptEN: 'Receipt',
    refund: 'Refund',
    refundEN: 'Refund',
    cancelRefund: 'Cancel Order / Refund',
    order: 'Order'
  },
  headers: {
    pricePerUnit: 'Price per Unit',
    qty: 'Quantity',
    opdNo: 'OPD Number',
    drugdispensing: 'Drug Dispensing Status',
    orderStatus: 'Order Status'
  },
  label: {
    sumInService: 'Included in Service Price',
    noSumInService: 'Not Included in Service Price',
    sumDiscount: 'Total Discount',
    totalDiscount: 'Total Discount Amount',
    allTotal: 'Grand Total',
    netTotal: 'Net Total',
    beforeVAT: 'Before VAT',
    clear: 'Clear',
    pauseBill: 'Pause Bill',
    pay: 'Pay',
    qty: 'Quantity',
    receiptId: 'Receipt Number',
    fnameLname: 'Full Name',
    printDate: 'Print Date',
    counter: 'Counter',
    pricePerUnit: 'Price per Unit',
    pack: 'Pack',
    episode: 'time',
    transfer: 'Bank Transfer',
    creditcard: 'Credit Card',
    cash: 'Cash',
    payee: 'Payee',
    serviceReceiver: 'Service receiver',
    medicationRecipient: 'Medication Recipient',
    orderId: 'Order ID',
    backToPOS: 'Back to Cashier',
    payment: 'Payment Method',
    noSpecified: 'Not Specified',
    specified: 'Specified',
    taxNo: 'Tax ID Number',
    taxName: 'Taxpayer Name',
    drugStatus: 'Drug Status',
    organizer: 'Organizer',
    value: 'Value',
    refundList: 'Refund Items',
    refundTotal: 'Total Refund Amount',
    printLabels: 'Print Medication Labels',
    medicationLabelInfo: 'Information for Medication Label'
  },
  placeholder: {
    searchPatientOPD: 'Search Patient, OPD Number',
    selectBank: 'Select Bank',
    taxNo: 'Enter Tax ID Number',
    taxName: 'Enter Taxpayer Name'
  },
  alert: {
    plzAddPOS: 'Please add items before creating an order.',
    plzAddCustomer: 'Please select a customer before creating an order.',
    confirmCancelTitle: 'Confirm Order Cancellation',
    confirmCancelSubtitle: 'Are you sure you want to cancel this order?',
    deleted: 'Order cancelled successfully!',
    plzEnterCorectTaxNo: 'Please enter a valid tax ID number.',
    plzEnterCorectTaxNo13: 'Please enter a 13-digit tax ID number.',
    confirmRefundTitle: 'Confirm Product Return / Refund'
  },
  status: {
    drugDispensingStatus: 'Drug Dispensing Status',
    all: 'All',
    wait: 'Waiting for Payment',
    received: 'Paid',
    refund: 'Refunded',
    cancel: 'Cancelled',
    paid: 'Paid'
  },
  toolTip: {
    createNew: 'Create New',
    seeOrderDetail: 'View Order Details',
    returnProduct: 'Return Product',
    panel: 'Panel'
  },
  bank: {
    kasikorn: 'Kasikorn Bank',
    scb: 'Siam Commercial Bank',
    krungthai: 'Krungthai Bank',
    tmb: 'TMB Bank',
    gsb: 'Government Savings Bank',
    bangkok: 'Bangkok Bank',
    bay: 'Bank of Ayudhya',
    tbank: 'Thanachart Bank',
    uob: 'UOB Bank',
    kk: 'Kiatnakin Phatra Bank',
    cimb: 'CIMB Thai Bank',
    tisco: 'TISCO Bank',
    lhb: 'Land and Houses Bank',
    ghb: 'Government Housing Bank',
    baac: 'Bank for Agriculture and Agricultural Cooperatives',
    islamic: 'Islamic Bank of Thailand'
  }
}
